import mixpanel from 'mixpanel-browser';
mixpanel.init('f460faa264f037b5e8251e77411b24e1');

let envCheck = process.env.REACT_APP_STAGE === 'production';

mixpanel.track_links("#nav a", "click nav link", {
	"referrer": document.referrer,
	'pathname': window.location.pathname
});

const actions = {
	identify: (id) => {
		// console.log('Mixpanel identify', id);
		if (envCheck) {
			mixpanel.identify(id);
		}
	},
	alias: (id) => {
		// console.log('Mixpanel alias', id);
		if (envCheck) {
			mixpanel.alias(id);
		}
	},
	track: (name, props) => {
		// console.log('Mixpanel track', name, props);
		if (envCheck) {
			mixpanel.track(name, props);
		}
	},
	reset: () => {
		// console.log('Mixpanel reset');
		if (envCheck) {
			mixpanel.reset();
		}
	},
	people: {
		set: (props) => {
			// console.log('Mixpanel people set', props);
			if (envCheck) {
				mixpanel.people.set(props);
			}
		}
	}
};

export const Mixpanel = actions;
